import fgtsImg from '@itau-loans-www/assets/images/zflow-link-fgts-img.png'
import consigImg from '@itau-loans-www/assets/images/zflow-link-inss-img.png'
import { Button, Likert } from '@itau-loans-www/components'
import { useProposal } from '@itau-loans-www/hooks'
import { getProduct } from '@itau-loans-www/utils'

import Layout from '../../layouts/Main'
import './zflow-link.scss'

const ZflowLink = () => {
  const product = getProduct()
  const proposalContext = useProposal()
  const link = proposalContext?.product?.linkZflow

  const img = {
    fgts: fgtsImg,
    consignado: consigImg
  }

  return (
    <Layout>
      <div className="zflow-link">
        <h1 className="zflow-link__title">
          Falta pouco! Finalize agora sua proposta com segurança
        </h1>
        <h3 className="zflow-link__subtitle">
          Em instantes, você também irá receber um link via SMS caso queira
          finalizar em outro momento
        </h3>

        <img
          src={img[product]}
          className="zflow-link__img"
          alt="foto de mulher sorrindo"
        />

        <Button tagName="a" fluid href={link} target="_blank">
          continuar
        </Button>

        <Likert />
      </div>
    </Layout>
  )
}

export default ZflowLink
